/**
 * DIEUKYDIEU.TV - AUDIO PLAYER SYNCED LYRICS & TIME DISPLAY
 */

import { t } from '../i18n.js';
import { audioPlaylist } from '../data/player-playlist.js';
import {
    currentAudioIndex,
    isRemainingTimeMode,
    currentLyricIndex,
    setIsRemainingTimeMode,
    setCurrentLyricIndex
} from './player-state.js';
import { updatePlayState } from './player-dom.js';

export function formatTime(s) {
    if (isNaN(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec < 10 ? '0' : ''}${sec}`;
}

export function formatTimeRemaining(currentTime, duration) {
    if (isNaN(duration) || duration <= 0) return "-0:00";
    const remaining = Math.max(0, duration - currentTime);
    const mins = Math.floor(remaining / 60);
    const secs = Math.floor(remaining % 60);
    return `-${mins}:${secs < 10 ? '0' : ''}${secs}`;
}

export function toggleTimeDisplayMode() {
    setIsRemainingTimeMode(!isRemainingTimeMode);
    const audioEl = document.getElementById('main-audio');
    const timeTot = document.getElementById('fp-time-total');
    if (audioEl && timeTot) {
        timeTot.innerText = isRemainingTimeMode 
            ? formatTimeRemaining(audioEl.currentTime, audioEl.duration) 
            : formatTime(audioEl.duration);
    }
}

export function getTrackSyncedLyrics(track) {
    if (!track) return [];
    if (track.syncedLyrics && Array.isArray(track.syncedLyrics) && track.syncedLyrics.length > 0) {
        return track.syncedLyrics;
    }
    if (!track.lyrics) return [];
    
    const lines = track.lyrics.split(/\r?\n/)
        .map(l => l.trim())
        .filter(l => l.length > 0 && !l.startsWith('(') && !l.startsWith('Lời:') && !l.startsWith('Biểu diễn:'));
    
    if (lines.length === 0) return [];
    
    let totalSec = 220;
    if (track.duration && track.duration.includes(':')) {
        const parts = track.duration.split(':');
        totalSec = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    }
    
    const startSec = 8;
    const endSec = Math.max(startSec + 20, totalSec - 15);
    const step = (endSec - startSec) / lines.length;
    
    return lines.map((text, idx) => ({
        time: Math.round(startSec + idx * step),
        text
    }));
}

export function renderSyncedLyrics(track) {
    const fpLyricsBody = document.getElementById('fp-lyrics-body');
    if (!fpLyricsBody) return;
    setCurrentLyricIndex(-1);

    const lyricsData = getTrackSyncedLyrics(track);
    if (lyricsData.length === 0) {
        fpLyricsBody.innerHTML = `<div class="apple-lyric-line active-line updating-line">${t('player_lyrics_updating') || 'Đang cập nhật lời bài hát...'}</div>`;
        return;
    }

    fpLyricsBody.innerHTML = lyricsData.map((item, idx) => `
        <div class="apple-lyric-line dimmed-line" id="lyric-line-${idx}" data-time="${item.time}" onclick="seekToLyricTime(${item.time})">
            ${item.text}
        </div>
    `).join('');
}

export function seekToLyricTime(time) {
    const audioEl = document.getElementById('main-audio');
    if (!audioEl) return;
    audioEl.currentTime = time;
    if (audioEl.paused) {
        audioEl.play().catch(e => console.warn(e));
        updatePlayState(true);
    }
    updateLyricsHighlight(time, true);
}

export function updateLyricsHighlight(currentTime, forceScroll = false) {
    if (currentAudioIndex < 0 || currentAudioIndex >= audioPlaylist.length) return;
    const track = audioPlaylist[currentAudioIndex];
    const lyricsData = getTrackSyncedLyrics(track);
    if (!lyricsData || lyricsData.length === 0) return;

    let activeIdx = -1;
    for (let i = 0; i < lyricsData.length; i++) {
        if (currentTime >= lyricsData[i].time) {
            activeIdx = i;
        } else {
            break;
        }
    }

    if (activeIdx !== currentLyricIndex || forceScroll) {
        setCurrentLyricIndex(activeIdx);
        const lineEls = document.querySelectorAll('.apple-lyric-line');
        lineEls.forEach((el, idx) => {
            if (idx === activeIdx) {
                el.classList.add('active-line');
                el.classList.remove('dimmed-line');
            } else {
                el.classList.remove('active-line');
                el.classList.add('dimmed-line');
            }
        });

        if (activeIdx >= 0) {
            const activeEl = document.getElementById(`lyric-line-${activeIdx}`);
            if (activeEl) {
                activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }
}
